<template>
    <video autoplay="true" preload="none" muted="true" loop="true" id="myVideo" poster="@/assets/img/bg-technology.jpg">
        <source src="@/assets/media/bg_animation.mp4" type="video/mp4">
        <!--source media="(max-width: 480px)" src="@/assets/video/fondo-piñata-may.mp4" type="video/mp4"-->
    </video>
</template>
<style scoped>
#myVideo {
    position: absolute;
    top: -35%;
    left: -1%;
    width: 100%;
    z-index: -1;
}

@media screen and (max-width: 768px) {
    #myVideo {
        position: fixed;
        min-width: 210%;
        height: auto;
        left: 2%;
        top: -5%;
        transform: translate(-30%);

    }
}
</style>